import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Clickable } from "../../button/Clickable";
import { Icon } from "../../graphic/Icon";
import { getModulePageLink } from "../../../utils/frontConstants";
import { useSiteLink } from "../../../utils/useSiteLink";
import styles from "./SiteModuleGrid.scss";

/**
 * Grid of module cards linking to each module page
 * @param modules – entries from FRONT_MODULES
 */
export const SiteModuleGrid = ({ modules, className }) => {
    const siteLink = useSiteLink();
    return (
        <ul className={classNames(styles.base, className)}>
            {modules.map((module) => (
                <li key={module.slug}>
                    <Clickable link={siteLink(getModulePageLink(module))} className={styles.card}>
                        <span className={styles.icon}>
                            <Icon name={module.icon} />
                        </span>
                        <span className={styles.name}>
                            <FormattedMessage id={`frontModules.${module.slug}.name`} />
                        </span>
                        <span className={styles.description}>
                            <FormattedMessage id={`frontModules.${module.slug}.description`} />
                        </span>
                    </Clickable>
                </li>
            ))}
        </ul>
    );
};
